import { motion } from "framer-motion";
import { ArrowUpRight, MessageCircle } from "lucide-react";
import { Reveal } from "./Reveal";
import { WA_NUMBER } from "../data/site";

const FinalCta = ({ openContact }) => (
  <section id="contact" data-testid="final-cta-section" className="relative py-32 md:py-44 overflow-hidden">
    <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_50%_120%,rgba(245,124,0,0.16),transparent_60%)]" />
    <div className="relative max-w-4xl mx-auto px-6 text-center">
      <Reveal>
        <p className="font-mono text-xs tracking-[0.35em] uppercase text-smipl-orange mb-6">08 / What's Next</p>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="font-display text-5xl sm:text-6xl lg:text-7xl font-extrabold tracking-tight leading-[1.02]">
          Let's Build<br /><span className="text-smipl-orange">What's Next.</span>
        </h2>
      </Reveal>
      <Reveal delay={0.2}>
        <p className="mt-7 text-slate-400 text-base md:text-lg max-w-xl mx-auto leading-relaxed">
          Tell us the outcome you need. We'll bring the architecture, the partners and the discipline to deliver it.
        </p>
      </Reveal>
      <Reveal delay={0.3}>
        <div className="mt-11 flex flex-wrap justify-center gap-4">
          <motion.button
            data-testid="cta-talk-btn"
            onClick={openContact}
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.98 }}
            className="flex items-center gap-2 rounded-full bg-smipl-orange text-white px-8 py-4 text-sm font-semibold glow-orange hover:bg-smipl-amber transition-colors duration-300"
          >
            Start a Conversation <ArrowUpRight size={16} />
          </motion.button>
          <motion.button
            data-testid="cta-whatsapp-btn"
            onClick={() => (WA_NUMBER ? window.open(`https://wa.me/${WA_NUMBER}`, "_blank") : openContact())}
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.98 }}
            className="flex items-center gap-2 rounded-full border border-wa/50 text-wa px-8 py-4 text-sm font-semibold hover:bg-wa hover:text-navy-deep transition-all duration-300"
          >
            <MessageCircle size={16} /> WhatsApp
          </motion.button>
        </div>
      </Reveal>
    </div>
  </section>
);

export default FinalCta;
